<template>
  <div class="about">
    <h1>Eine seite um besser Vue-Router zu verstehen</h1>
  </div>
</template>
